import { APP_CONFIG } from "../constants";

export const optionsService = {
  getLojas: async () => {
    const response = await fetch(`${APP_CONFIG.API_URL}/lojas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) throw new Error("Erro ao buscar lojas");
    return response.json();
  },

  getRoles: async (lojaId?: number, incluirOcultas = false) => {
    const params = new URLSearchParams({ paraFormulario: "true" });
    if (lojaId) params.set("lojaId", String(lojaId));
    if (incluirOcultas) params.set("incluirOcultas", "true");
    const response = await fetch(
      `${APP_CONFIG.API_URL}/roles?${params.toString()}`,
      {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) throw new Error("Erro ao buscar roles");
    return response.json();
  },

  getUsuarios: async () => {
    const response = await fetch(
      `${APP_CONFIG.API_URL}/usuarios?page=1&limit=1000`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) throw new Error("Erro ao buscar usuários");
    const json = await response.json();
    return json.data ?? [];
  },
};
